import { useEffect } from 'react';

import { startReportScrolledTracking } from '@/lib/reportScrolled';

type UsePostHogReportScrolledParams = {
  enabled?: boolean;
  reportId?: string | null;
};

export const usePostHogReportScrolled = ({
  enabled = true,
  reportId,
}: UsePostHogReportScrolledParams) => {
  useEffect(() => {
    if (!enabled || !reportId) return;
    return startReportScrolledTracking(reportId);
  }, [enabled, reportId]);
};
